import { ReactNode } from "react";

export interface DetailItem {
  label: string;
  value: ReactNode;
}

export const DetailList = ({ items }: { items: DetailItem[] }) => (
  <dl className="divide-y divide-border">
    {items.map(({ label, value }, index) => (
      <div
        key={`${label}-${index}`}
        className="flex items-start justify-between gap-4 py-2 text-sm"
      >
        <dt className="text-muted-foreground">{label}</dt>
        <dd className="text-right font-medium text-foreground">{value ?? "–"}</dd>
      </div>
    ))}
  </dl>
);
